import React, {useState,useCallback} from 'react';
import HomeSectionTitle from "../../HomeSectionTitle";
import Rule from "./Rule";
import {Text} from "../../Text";
import "./Philosophy.scss";


const Philosophy = ({sectionTitle, rules, inView}) => {

	const [sectionExpanded,setSectionExpanded] = useState(false);

	const handleToggle = useCallback( e => {
		e.preventDefault()
		if(sectionExpanded) {
			setSectionExpanded(false);
			const el = document.getElementById('philosophy');
			const posY = el.offsetTop;
			const posYoffset = window.innerWidth < 769 ? -141 : -100;
			window.scrollTo({
				top: posY + posYoffset,
				behavior: "smooth"
			});
		} else {
			setSectionExpanded(true);
		}
	},[sectionExpanded,setSectionExpanded])

	return (
		<div className="philosophy" id="philosophy">
			<div className="row center-xs">
				<div className="col col-xs-12">
					<div className="row boxed" id="philosophy__inner">
						<div className="col col-xs-12 philosophy__title">
							<HomeSectionTitle text={sectionTitle}/>
						</div>
						<div className="col col-xs-12 philosophy__content">
							{rules
								.filter((rule,index) => !sectionExpanded ? index === 0 : rule)
								.map(rule => <Rule key={rule.zasada_tytul} rule={rule} />)
							}
						</div>
						<div className="col col-xs-12 philosophy__trigger">
							<Text
								code={sectionExpanded ? "zamknij" : "wczytaj_wiecej"}
								tag="button"
								className="btn__primary"
								aria-expanded={sectionExpanded}
								target="_top"
								onClick={e=>handleToggle(e)}
								data-sticky={sectionExpanded && inView}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Philosophy;